'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

export default function NotFound() {
  const router = useRouter();

  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] px-6">
      <div className="text-center max-w-md">
        <p className="lz-mono text-[13px] mb-6">404</p>
        <h1 className="lz-h2 mb-4">Page introuvable</h1>
        <p className="lz-body max-w-sm mx-auto mb-10">
          Cette page n&apos;existe pas ou a été déplacée. Revenez à l&apos;accueil.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={handleGoBack}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-white/[0.08] text-[14px] font-medium text-[#929792] hover:text-white hover:border-white/[0.16] transition-all duration-200"
          >
            ← Retour
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-[14px] font-semibold transition-all duration-200 hover:opacity-90"
            style={{ background: '#70F59A', color: '#050505' }}
          >
            Accueil
          </Link>
        </div>
      </div>
    </div>
  );
}